import {
  GET,
  POST,
} from "../../apiController";

const endpoint = "/admin/courses";

// get course performance stats (enrollments, completed, in progress, etc.)
export const coursePerformance = (courseId) => {
  return GET(endpoint + `/course_stats/${courseId}`);
};

// get course performance details with pagination and filters
export const coursePerformanceDetails = (data) => {
  return GET(
    endpoint +
    `/course_user_details/${data.course_id}?search=${data.search}&page=${data.page}&limit=${data.limit}&status=${data.status}`
  );
};

// get complete course analytics report payload for modal + Excel export
export const getCourseAnalyticsReport = (courseId) => {
  return GET(endpoint + `/course_report/${courseId}`);
};

export const generateCourseCertificates = (data) => {
  return POST(endpoint + `/course_certificates/generate`, data);
};

export const getCertificateMediaUrl = (certificateId) => {
  return GET(`/media/certificate/${certificateId}`);
};

// get course surveys
export const getCourseSurveys = (data) => {
  return POST(endpoint + `/course_surveys`, data);
};

// get course assessments
export const getCourseAssessments = (data) => {
  return POST(endpoint + `/course_assessments`, data);
};

// get assessment details
export const getAssessmentDetails = (assessmentId) => {
  return GET(endpoint + `/assessment_details/${assessmentId}`);
};

export const getAssessmentTraineeAnswers = (assessmentId, userId) => {
  return GET(endpoint + `/assessment_details/${assessmentId}/trainees/${userId}/answers`);
};

// get single survey details
export const singleSurveyDetails = (data) => {
  return POST(endpoint + `/single_survey_details`, data);
};

// get course user activity
export const courseUserActivity = (courseId) => {
  return GET(endpoint + `/course_activity/${courseId}`);
};
